import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRegisteredProfessionals,
  fetchFeaturedProfessionals,
  fetchProfessionalJurisdictions,
  fetchProfessionalSkills,
} from "../store/profesionales/thunks.ts";

type RootState = {
  general?: {
    usersRegisteredData?: any[];
    componentLoading?: boolean;
  };
  register?: {
    skillsList?: any[];
  };
  profile?: {
    usersInJurisdiction?: any[];
  };
};

const useProfesionalesBootstrap = () => {
  const dispatch = useDispatch<any>();
  const hasFetchedRef = useRef(false);

  const usersLoaded = useSelector((state: RootState) => !!state.general?.usersRegisteredData?.length);
  const skillsLoaded = useSelector((state: RootState) => !!state.register?.skillsList?.length);
  const jurisdictionsLoaded = useSelector(
    (state: RootState) => !!state.profile?.usersInJurisdiction?.length
  );
  const isLoading = useSelector((state: RootState) => state.general?.componentLoading ?? false);

  useEffect(() => {
    if (hasFetchedRef.current) return;
    if (usersLoaded && skillsLoaded && jurisdictionsLoaded) return;

    hasFetchedRef.current = true;
    dispatch(fetchRegisteredProfessionals());
    dispatch(fetchFeaturedProfessionals());
    dispatch(fetchProfessionalSkills());
    dispatch(fetchProfessionalJurisdictions());
  }, [dispatch, jurisdictionsLoaded, skillsLoaded, usersLoaded]);

  return {
    isLoading,
    usersLoaded,
    skillsLoaded,
    jurisdictionsLoaded,
  };
};

export default useProfesionalesBootstrap;

